import React, {useState, useEffect, useCallback} from 'react'
import './../../App.css';
import './Reports.css';
import axios from '../../api/apiClient';
import {token, domain} from '../Security';
import loadingSpinner from './../../assets/loading.gif';
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
//icons
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function BIR1601C({isHideSideMenu}) {
    const [loading, setLoading] = useState(false);
    const [companyId, setCompanyId] = useState(0);
    const [company, setCompany] = useState(null);
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");

    const [errorState, setErrorState] = useState(false);

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const generate = () =>{
        if(!company || !month || !year){
            setErrorState(true);
            return;
        }
        setErrorState(false);
        fetchData();
    };

    const numberWithCommasAndDecimal = (number) => {
        if(!number){
            return "0.00";
        }
        return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const writeFont8Black = ({page, font, x, y, text}) => {
        page.drawText(text, {
            x: x,  // Adjust X position
            y: y,  // Adjust Y position
            size: 8, 
            font: font,
            color: rgb(0, 0, 0), // Black text
        })
    }
    const writeFont12Black = ({page, font, x, y, text}) => {
        page.drawText(text, {
            x: x,  // Adjust X position
            y: y,  // Adjust Y position
            size: 12, 
            font: font,
            color: rgb(0, 0, 0), // Black text
        })
    }

    const modifyAndDownloadPDF = useCallback(async (data) => {
        try {
            console.log("data", data)
            // Load the existing PDF from the public folder
            const pdfUrl = `${window.location.origin}/docs/BIR_1601C.pdf`;
    
            // Fetch the existing PDF as a binary array
            const response = await fetch(pdfUrl);
            const pdfBytes = await response.arrayBuffer();
    
            // Load the PDF with pdf-lib
            const pdfDoc = await PDFDocument.load(pdfBytes);
    
            // Get the first page of the PDF
            const page = pdfDoc.getPages()[0];
            const font = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
            const dingbatsFont = await pdfDoc.embedFont(StandardFonts.ZapfDingbats);

            //CONTENT
            //month
            const monthNumber = ("0" + (new Date(`${month} 1, 2000`).getMonth() + 1)).slice(-2);
            const monthStr = monthNumber.toString(); // ensure it's a string
                [...monthStr].forEach((text, index) => {
                    writeFont8Black({
                        page: page,
                        font: font,
                        x: 50 + (index * 14),
                        y: 815,
                        text: text
                    });
                });
            //year
            const yearStr = year.toString(); // ensure it's a string
                [...yearStr].forEach((text, index) => {
                    writeFont8Black({
                        page: page,
                        font: font,
                        x: 80 + (index * 14),
                        y: 815,
                        text: text
                    });
                });

            const amended = false;
            if(amended){
                writeFont12Black({page: page, font: dingbatsFont, x: 187.5, y: 815, text: "✓"})
            } else {
                writeFont12Black({page: page, font: dingbatsFont, x: 235, y: 815, text: "✓"})
            }

            const anyTaxesWithheld = false;
            if(anyTaxesWithheld){
                writeFont12Black({page: page, font: dingbatsFont, x: 308, y: 815, text: "✓"})
            } else {
                writeFont12Black({page: page, font: dingbatsFont, x: 350, y: 815, text: "✓"})
            }

            //no of sheets
            /* const noOfSheets = 2;
            const noOfSheetsStr = noOfSheets.toString(); // ensure it's a string
                [...noOfSheetsStr].forEach((text, index) => {
                    writeFont8Black({
                        page: page,
                        font: font,
                        x: 452 + (index * 14),
                        y: 815,
                        text: text
                    });
                }); */

            //company tin
            const tinInitialValue = data.companyTin ?? null;
            if(tinInitialValue){
                const tinNumberOnly = tinInitialValue.replace(/\D/g, "");

                const tinArray = tinNumberOnly.split("");
                const tinText = {
                    firstPart: tinArray.slice(0, 3).map(data => data),
                    secondPart: tinArray.slice(3, 6).map(data => data),
                    thirdPart: tinArray.slice(6, 9).map(data => data),
                    fourthPart: tinArray.slice(9).map(data => data), // The rest
                };

                tinText.firstPart.forEach((text, index) => {
                    writeFont8Black({page: page, font: font, x: 238.5 + (index * 13), y: 782, text: `${text}`})
                })
                tinText.secondPart.forEach((text, index) => {
                    writeFont8Black({page: page, font: font, x: 295 + (index * 13), y: 782, text: `${text}`})
                })
                tinText.thirdPart.forEach((text, index) => {
                    writeFont8Black({page: page, font: font, x: 352.5 + (index * 13), y: 782, text: `${text}`})
                })
                tinText.fourthPart.forEach((text, index) => {
                    writeFont8Black({page: page, font: font, x: 410 + (index * 14), y: 782, text: `${text}`})
                })
            }

            //company name
            const companyName = data.companyName ?? null; // ensure it's a string
                [...companyName].forEach((text, index) => {
                    writeFont8Black({
                        page: page,
                        font: font,
                        x: 22.5 + (index * 14.3),
                        y: 756,
                        text: text
                    });
                });

            //company address
            const companyAddress = data.companyAddress ?? '';
            const maxCharsPerLine = 40;
            const lineHeight = 16;

            const lines = [];
            for (let i = 0; i < companyAddress.length; i += maxCharsPerLine) {
            lines.push(companyAddress.slice(i, i + maxCharsPerLine));
            }

            lines.forEach((line, lineIndex) => {
                [...line].forEach((text, charIndex) => {
                    writeFont8Black({
                    page: page,
                    font: font,
                    x: 22.5 + (charIndex * 14.3),
                    y: 730 - (lineIndex * lineHeight), // move to next line if exceeded
                    text: text
                    });
                });
            });

            const isPrivate = false;
            if(isPrivate){
                writeFont12Black({page: page, font: dingbatsFont, x: 450, y: 698, text: "✓"})
            } else {
                writeFont12Black({page: page, font: dingbatsFont, x: 525, y: 698, text: "✓"})
            }

            const payees = false;
            if(payees){
                writeFont12Black({page: page, font: dingbatsFont, x: 178, y: 661, text: "✓"})
            } else {
                writeFont12Black({page: page, font: dingbatsFont, x: 223, y: 661, text: "✓"})
            }

            //Less Total Non Taxable Compensation
            const _lessTotalNonTaxableCompensation = numberWithCommasAndDecimal(data.totalNetPay)

            const lessTotalNonTaxableCompensation = data.totalNetPay ? _lessTotalNonTaxableCompensation.toString() : null;
            if (lessTotalNonTaxableCompensation) {
                // Extract only digits and decimal point
                const cleanedValue = lessTotalNonTaxableCompensation.replace(/[^\d.]/g, "");

                // Split into whole and decimal parts
                const [wholePart, decimalPart = ""] = cleanedValue.split(".");

                // Break each part into an array of digits
                const wholeArray = wholePart.split("");
                const decimalArray = decimalPart.split("");

                // Draw whole number part (before decimal)
                wholeArray.forEach((text, index) => {
                    writeFont8Black({
                        page,
                        font,
                        x: 395 + (index * 14.3),
                        y: 630,
                        text
                    });
                });

                decimalArray.forEach((text, index) => {
                    writeFont8Black({
                        page,
                        font,
                        x: 570 + (index * 14.3),
                        y: 630,
                        text
                    });
                });
            }

            //Statutory Minimum Wage
            const _statutoryMinimumWage = numberWithCommasAndDecimal(data.statutoryMinimumWage)

            const statutoryMinimumWage = data.lessTotalNonTaxableCompensation ? _statutoryMinimumWage.toString() : null;
            if (statutoryMinimumWage) {
                // Extract only digits and decimal point
                const cleanedValue = statutoryMinimumWage.replace(/[^\d.]/g, "");

                // Split into whole and decimal parts
                const [wholePart, decimalPart = ""] = cleanedValue.split(".");

                // Break each part into an array of digits
                const wholeArray = wholePart.split("");
                const decimalArray = decimalPart.split("");

                // Draw whole number part (before decimal)
                wholeArray.forEach((text, index) => {
                    writeFont8Black({
                        page,
                        font,
                        x: 395 + (index * 14.3),
                        y: 605,
                        text
                    });
                });

                decimalArray.forEach((text, index) => {
                    writeFont8Black({
                        page,
                        font,
                        x: 570 + (index * 14.3),
                        y: 605,
                        text
                    });
                });
            }

            //Other Pay for MWE
            const _otherPayForMWE = numberWithCommasAndDecimal(data.otherPayForMWE)

            const otherPayForMWE = data.otherPayForMWE ? _otherPayForMWE.toString() : null;
            if (otherPayForMWE) {
                // Extract only digits and decimal point
                const cleanedValue = otherPayForMWE.replace(/[^\d.]/g, "");

                // Split into whole and decimal parts
                const [wholePart, decimalPart = ""] = cleanedValue.split(".");

                // Break each part into an array of digits
                const wholeArray = wholePart.split("");
                const decimalArray = decimalPart.split("");

                // Draw whole number part (before decimal)
                wholeArray.forEach((text, index) => {
                    writeFont8Black({
                        page,
                        font,
                        x: 395 + (index * 14.3),
                        y: 588,
                        text
                    });
                });

                decimalArray.forEach((text, index) => {
                    writeFont8Black({
                        page,
                        font,
                        x: 570 + (index * 14.3),
                        y: 588,
                        text
                    });
                });
            }

            //13th month
            const _nonTaxable13thMonth = numberWithCommasAndDecimal(data.nonTaxable13thMonth)

            const nonTaxable13thMonth = data.nonTaxable13thMonth ? _nonTaxable13thMonth.toString() : null;
            if (nonTaxable13thMonth) {
                // Extract only digits and decimal point
                const cleanedValue = otherPayForMWE.replace(/[^\d.]/g, "");

                // Split into whole and decimal parts
                const [wholePart, decimalPart = ""] = cleanedValue.split(".");

                // Break each part into an array of digits
                const wholeArray = wholePart.split("");
                const decimalArray = decimalPart.split("");

                // Draw whole number part (before decimal)
                wholeArray.forEach((text, index) => {
                    writeFont8Black({
                        page,
                        font,
                        x: 395 + (index * 14.3),
                        y: 573,
                        text
                    });
                });

                decimalArray.forEach((text, index) => {
                    writeFont8Black({
                        page,
                        font,
                        x: 570 + (index * 14.3),
                        y: 573,
                        text
                    });
                });
            }

            //DeMinimis Benefits
            const _deMinimisBenefits = numberWithCommasAndDecimal(data.deMinimisBenefits)

            const deMinimisBenefits = data.deMinimisBenefits ? _deMinimisBenefits.toString() : null;
            if (deMinimisBenefits) {
                // Extract only digits and decimal point
                const cleanedValue = deMinimisBenefits.replace(/[^\d.]/g, "");

                // Split into whole and decimal parts
                const [wholePart, decimalPart = ""] = cleanedValue.split(".");

                // Break each part into an array of digits
                const wholeArray = wholePart.split("");
                const decimalArray = decimalPart.split("");

                // Draw whole number part (before decimal)
                wholeArray.forEach((text, index) => {
                    writeFont8Black({
                        page,
                        font,
                        x: 395 + (index * 14.3),
                        y: 556,
                        text
                    });
                });

                decimalArray.forEach((text, index) => {
                    writeFont8Black({
                        page,
                        font,
                        x: 570 + (index * 14.3),
                        y: 556,
                        text
                    });
                });
            }

            //Contribution
            const _contributions = numberWithCommasAndDecimal(data.contributions)

            const contributions = data.contributions ? _contributions.toString() : null;
            if (contributions) {
                // Extract only digits and decimal point
                const cleanedValue = contributions.replace(/[^\d.]/g, "");

                // Split into whole and decimal parts
                const [wholePart, decimalPart = ""] = cleanedValue.split(".");

                // Break each part into an array of digits
                const wholeArray = wholePart.split("");
                const decimalArray = decimalPart.split("");

                // Draw whole number part (before decimal)
                wholeArray.forEach((text, index) => {
                    writeFont8Black({
                        page,
                        font,
                        x: 395 + (index * 14.3),
                        y: 543,
                        text
                    });
                });

                decimalArray.forEach((text, index) => {
                    writeFont8Black({
                        page,
                        font,
                        x: 570 + (index * 14.3),
                        y: 543,
                        text
                    });
                });
            }

            //Total Non Taxable Compensation
            const _totalNonTaxableCompensation = numberWithCommasAndDecimal(data.totalNonTaxableCompensation)

            const totalNonTaxableCompensation = data.totalNonTaxableCompensation ? _totalNonTaxableCompensation.toString() : null;
            if (totalNonTaxableCompensation) {
                // Extract only digits and decimal point
                const cleanedValue = totalNonTaxableCompensation.replace(/[^\d.]/g, "");

                // Split into whole and decimal parts
                const [wholePart, decimalPart = ""] = cleanedValue.split(".");

                // Break each part into an array of digits
                const wholeArray = wholePart.split("");
                const decimalArray = decimalPart.split("");

                // Draw whole number part (before decimal)
                wholeArray.forEach((text, index) => {
                    writeFont8Black({
                        page,
                        font,
                        x: 395 + (index * 14.3),
                        y: 508,
                        text
                    });
                });

                decimalArray.forEach((text, index) => {
                    writeFont8Black({
                        page,
                        font,
                        x: 570 + (index * 14.3),
                        y: 508,
                        text
                    });
                });
            }

            //Total Taxable Compensation
            const _totalTaxableCompensation = numberWithCommasAndDecimal(data.totalTaxableCompensation)

            const totalTaxableCompensation = data.totalTaxableCompensation ? _totalTaxableCompensation.toString() : null;
            if (totalTaxableCompensation) {
                // Extract only digits and decimal point
                const cleanedValue = totalTaxableCompensation.replace(/[^\d.]/g, "");

                // Split into whole and decimal parts
                const [wholePart, decimalPart = ""] = cleanedValue.split(".");

                // Break each part into an array of digits
                const wholeArray = wholePart.split("");
                const decimalArray = decimalPart.split("");

                // Draw whole number part (before decimal)
                wholeArray.forEach((text, index) => {
                    writeFont8Black({
                        page,
                        font,
                        x: 395 + (index * 14.3),
                        y: 493,
                        text
                    });
                });

                decimalArray.forEach((text, index) => {
                    writeFont8Black({
                        page,
                        font,
                        x: 570 + (index * 14.3),
                        y: 493,
                        text
                    });
                });
            }

            //Less Total Taxable Compensation
            const _lessTotalTaxableCompensation = numberWithCommasAndDecimal(data.lessTotalTaxableCompensation)

            const lessTotalTaxableCompensation = data.lessTotalTaxableCompensation ? _lessTotalTaxableCompensation.toString() : null;
            if (lessTotalTaxableCompensation) {
                // Extract only digits and decimal point
                const cleanedValue = lessTotalTaxableCompensation.replace(/[^\d.]/g, "");

                // Split into whole and decimal parts
                const [wholePart, decimalPart = ""] = cleanedValue.split(".");

                // Break each part into an array of digits
                const wholeArray = wholePart.split("");
                const decimalArray = decimalPart.split("");

                // Draw whole number part (before decimal)
                wholeArray.forEach((text, index) => {
                    writeFont8Black({
                        page,
                        font,
                        x: 395 + (index * 14.3),
                        y: 476,
                        text
                    });
                });

                decimalArray.forEach((text, index) => {
                    writeFont8Black({
                        page,
                        font,
                        x: 570 + (index * 14.3),
                        y: 476,
                        text
                    });
                });
            }

            //Net Taxable Compensation
            const _netTaxableCompensation = numberWithCommasAndDecimal(data.netTaxableCompensation)

            const netTaxableCompensation = data.netTaxableCompensation ? _netTaxableCompensation.toString() : null;
            if (netTaxableCompensation) {
                // Extract only digits and decimal point
                const cleanedValue = netTaxableCompensation.replace(/[^\d.]/g, "");

                // Split into whole and decimal parts
                const [wholePart, decimalPart = ""] = cleanedValue.split(".");

                // Break each part into an array of digits
                const wholeArray = wholePart.split("");
                const decimalArray = decimalPart.split("");

                // Draw whole number part (before decimal)
                wholeArray.forEach((text, index) => {
                    writeFont8Black({
                        page,
                        font,
                        x: 395 + (index * 14.3),
                        y: 461,
                        text
                    });
                });

                decimalArray.forEach((text, index) => {
                    writeFont8Black({
                        page,
                        font,
                        x: 570 + (index * 14.3),
                        y: 461,
                        text
                    });
                });
            }

            //Total Tax
            const _totalTax = numberWithCommasAndDecimal(data.totalTax)

            const totalTax = data.totalTax ? _totalTax.toString() : null;
            if (totalTax) {
                // Extract only digits and decimal point
                const cleanedValue = totalTax.replace(/[^\d.]/g, "");

                // Split into whole and decimal parts
                const [wholePart, decimalPart = ""] = cleanedValue.split(".");

                // Break each part into an array of digits
                const wholeArray = wholePart.split("");
                const decimalArray = decimalPart.split("");

                // Draw whole number part (before decimal)
                wholeArray.forEach((text, index) => {
                    writeFont8Black({
                        page,
                        font,
                        x: 395 + (index * 14.3),
                        y: 446,
                        text
                    });
                });

                decimalArray.forEach((text, index) => {
                    writeFont8Black({
                        page,
                        font,
                        x: 570 + (index * 14.3),
                        y: 446,
                        text
                    });
                });
            }

            setShowRequestMessage(true);
            setIsSuccess(true);
    
            // Save the modified PDF
            const modifiedPdfBytes = await pdfDoc.save();
            const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
    
            // Trigger download
            const a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = `BIR_1601C_${data.lastName}_${data.firstName}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(a.href);
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        }
        
        setLoading(false);
    }, [month, year]);

    const fetchDataCompany = useCallback(async () => {
        const apiUrl =  domain + `/api/Company/${companyId}`;

        try {
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})
            
            return response.data;
        } catch (error) {
            return null
        }
    }, [companyId]);

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + `/api/Reports/BIR1601C/company/${companyId}/month/${month}/year/${year}`;

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})

            const _company = await fetchDataCompany();
            setCompany(_company)

            modifyAndDownloadPDF(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }, [fetchDataCompany, modifyAndDownloadPDF, companyId, month, year]);

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="ReportsInfo shadow-xl">
                        <div className="reports-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Reports >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"BIR Form No. 1601C"}</span>
                            </div>
                            <h3>Generate BIR Form No. 1601C</h3>
                        </div>
                        <div className="reports-body">
                            <div className="info-item-holder row items-center">
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Company</div>
                                    <div className="info-item-input">
                                        <CompanyTypeSelect companyId={companyId} setCompanyId={setCompanyId} setCompany={setCompany}/>
                                    </div>
                                    <span style={{
                                                visibility: !companyId && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Month</div>
                                    <div className="info-item-input">
                                        <Month month={month} setMonth={setMonth}/>
                                    </div>
                                    <span style={{
                                                visibility: !month && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Year</div>
                                    <div className="info-item-input">
                                        <Year year={year} setYear={setYear}/>
                                    </div>
                                    <span style={{
                                                visibility: !year && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="reports-footer">
                            <div className="buttons row" style={{justifyContent:"start"}}>
                                <button id="sssReportGenerate"
                                    className="generate row" 
                                    onClick={generate}
                                    > GENERATE
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loading? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function CompanyTypeSelect({companyId, setCompanyId, setCompany}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const selectedCompanyId = event.target.value; // Get the selected company ID
        setCompanyId(selectedCompanyId);
        const selectedCompany = data.find((comp) => comp.id.toString() === selectedCompanyId.toString()); // Find the full company object

        if (selectedCompany) {
            setCompany(selectedCompany); // Set the full company object
        }
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Company/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.name.localeCompare(b.name));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if (companyId !== "" && companyId !== 0 && companyId !== null && companyId !== undefined && companyId.length !== 0) {
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [companyId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={companyId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose company type</option>
            {data.map((companyId) => ( 
                SetCompanyType(companyId)
            ))}
            </select>
        </div>
    );
};
function SetCompanyType(company){
    return(
        <option value={company.id}>{
            company.name}
        </option>
    )

}
function Month({month, setMonth}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setMonth(event.target.value);
        setIsSelected(true);
    };

    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    
    useEffect(() => {
        if(month !== "" && month !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [month]);

    return (
        <div>
            <select id="monthSSSReport-select" value={month} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
                <option value="" disabled hidden>Choose a month</option>
                {months.map((monthName, index) => (
                    <option key={index} value={monthName}>{monthName}</option>
                ))}
            </select>
        </div>
    );
};
function Year({year, setYear}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setYear(event.target.value);
        setIsSelected(true);
    };

    // Generate years from 2019 to the current year
    const getCurrentYear = () => new Date().getFullYear();
    const startYear = 2019;
    const years = Array.from({ length: getCurrentYear() - startYear + 1 }, (_, index) => (startYear + index).toString()).reverse();;

    useEffect(() => {
        if(year !== "" && year !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [year]);

    return (
        <div>
            <select id="yearSSSReport-select" value={year} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose a year</option>
            {years.map((yearName, index) => (
                <option key={index} value={yearName}>{yearName}</option>
            ))}
            </select>
        </div>
    );
};

export default BIR1601C
